/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016-2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.assetLibraryModule')
.directive('bulbAssetlibraryAddVideoPane', ['BulbAssetLibraryService','BulbBusyCoverService','$q', bulbAssetlibraryAddVideoPane]);

function bulbAssetlibraryAddVideoPane(BulbAssetLibraryService, BulbBusyCoverService, $q) {
  return {
    restrict: 'E',
    transclude: true,
    templateUrl: 'ajs/assetlibrary/modal/add-video-pane.html',
    controllerAs: 'addVideoModalCtrl',
    controller: ['$scope', function($scope) {
      var that = this;
      this.videoUrl = null;
      this.videoUrlErrorMessage = null;
      this.assetContainerCtrl = null;

      var errorHandler = function(res) {
        that.videoUrlErrorMessage = res.data.message;
      };

      // create YouTube / Vimeo video
      this.createExternalServiceVideo = function() {

        var deferred = $q.defer();
        BulbBusyCoverService.showBusyDuring(deferred.promise);

        if ($scope.selectionModal) {
          // selection modal
          that.createExternalServiceVideoHandler(that.videoUrl)
            .then(null, errorHandler).finally(deferred.resolve);

        } else {
          // other
          BulbAssetLibraryService.api.createExternalServiceVideo(that.assetContainerCtrl.currentFolderId,
            that.videoUrl, true).then(function(res) {
              BulbAssetLibraryService.dialog.dismissAllModals();
              that.assetContainerCtrl.getEntriesAndUpdateList();
            }, errorHandler).finally(deferred.resolve);
        }
      };
    }],
    link: function(scope, element, attrs, addVideoModalCtrl, $log) {
      addVideoModalCtrl.assetContainerCtrl = scope.assetContainerCtrl;
      addVideoModalCtrl.createExternalServiceVideoHandler = scope.createExternalServiceVideoHandler;
      scope.selectionModal = attrs.selectionModal;
    }
  };
}
